<template>
	<div class=''>
		<Select class='' name='number' groupClass='bg-white text-15' placeholder='Select phone number'
			v-model:value='value.number'
			:options='options'>
        </Select>

        <!-- <Select class='mt-2' name='template' groupClass='bg-white text-15' :value='null' placeholder='Select template'>
            <option :value='null'></option>
        </Select> -->

		<Textarea name='description' class='mt-2 transition-all duration-500 ease-in-out'
			:textareaClass='["transition-all duration-500 ease-in-out", {
				"min-h-[473px]": size,
				"min-h-[134px]": !size,
			}]'
			v-model:value='value.description'
			:limit='360'
			rows='4'
		/>
	</div>
</template>

<script>
	import SMS from '~/models/sms.js';

	export default {
		props: {
			size: Boolean,
			communications: {
				type: Array,
				deafult: []
			},
			editing: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				value: SMS.form(this.editing)
			}
		},

		computed: {
			options() {
				return this.communications.filter(c => c.type == 0).map((n) => {
					return {
						value: this.$help.e164ToNumber(n.value)
					}
				})
			}
		}
	}
</script>